import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import AuthGuard from './AuthGuard';
import Loadable from 'src/components/Loadable';

const AccountView = Loadable(
  lazy(() => import('src/views/account/AccountView'))
);

const SectionEditView = Loadable(
  lazy(() => import('src/views/sections/EditView'))
);

const SectionCreateView = Loadable(
  lazy(() => import('src/views/sections/CreateView'))
);

const SectionDetailsView = Loadable(
  lazy(() => import('src/views/sections/DetailsView'))
);

const SectionListView = Loadable(
  lazy(() => import('src/views/sections/ListView'))
);

// ==============================|| PRIVATE ROUTING ||============================== //

const PrivateRoutes = {
  path: '/',
  element: <AuthGuard />,
  children: [
    {
      path: '/',
      element: <Navigate to="/sections" />
    },
    {
      path: '/account',
      element: <AccountView />
    },
    {
      path: '/sections/:sectionId/edit',
      element: <SectionEditView />
    },
    {
      path: '/sections/:sectionId',
      element: <SectionDetailsView />
    },
    {
      path: '/sections/create',
      element: <SectionCreateView />
    },
    {
      path: '/sections',
      element: <SectionListView />
    },
    {
      element: <Navigate to="/404" />
    }
  ]
};

export default PrivateRoutes;
